<template>
  <div class="default-container">
    <!-- <b-carousel :indicator-inside="false">
      <b-carousel-item v-for="(item, i) in 2" :key="i">
        <b-image class="image" :src="getImgUrl(i)" />
      </b-carousel-item>
    </b-carousel> -->
    <!-- banner -->
    <div class="index-top">
      <div class="index-top-wrap">
        <div class="index-top-l">
          <b-carousel :indicator-inside="false" :indicator="false" :autoplay="true" :interval="5000" :pauseHover="false">
            <b-carousel-item v-for="(item, i) in bannerList" :key="i">
              <img class="image" :src="item.image" />
            </b-carousel-item>
          </b-carousel>
        </div>
        <div class="index-top-r">
          <div class="index-top-r-wrap">
            <div class="index-top-r-top">
              <div class="index-top-r-top-tabs">
                <div class="index-top-r-top-tabs-item" :class="{ 'tab-active': tabIndex == 0 }" @click="changeTab(0)">
                  学术会议
                </div>
                <div class="index-top-r-top-tabs-item" :class="{ 'tab-active': tabIndex == 1 }" @click="changeTab(1)">
                  直播课堂
                </div>
              </div>
              <div class="index-top-r-top-more" @click="routerTo">更多</div>
            </div>
            <div class="index-top-r-cent" v-if="total > 0">
              <div class="index-top-r-cent-li" v-for="(item, index) in liveList" :key="index"
                @click="handleClickLive(item)">
                <div class="index-top-r-cent-li-title"><span></span>{{ item.title }}</div>
                <div class="index-top-r-cent-li-time" v-if="tabIndex == 0">{{ parseTime(item.dateStr, '{y}-{m}-{d}') }}</div>
                <div class="index-top-r-cent-li-time" v-else>{{ parseTime(item.liveStartTime, '{y}-{m}-{d} {h}:{i}') }}</div>
              </div>
            </div>
            <!-- 空数据 -->
            <div class="no-data" v-else>
              <b-image :src="require('@/assets/null-data.png')"></b-image>
              <div class="no-data-text">暂无数据~</div>
            </div>
            <!-- 加载动画 -->
            <b-loading :is-full-page="true" v-model="loading" :can-cancel="true"></b-loading>
          </div>
        </div>
      </div>
    </div>
    <!-- 超声教育 -->
    <div class="img-item bg2">
      <div class="csjy-title">
        <img class="csjy-title-img" src="../assets/image/csjy-title.png" alt="title" />
      </div>
      <div class="csjy-content">
        <div class="csjy-content-l">
          <div class="csjy-content-l-item" v-for="(item, index) in courseList" :key="index">
            <div class="item-title">{{ item.code | formatCourseCode }}</div>
            <div class="item-f-title">{{ item.cnName }}</div>
            <div class="item-text-div">
              <div class="item-text">{{ item.description }}</div>
            </div>
            <div class="item-info" @click="$router.push(`/course/${item.id}`)">
              查看详情 <img src="../assets/image/csjt1.png" alt="jt" />
            </div>
          </div>
        </div>
        <div class="csjy-content-r">
          <img src="@/assets/image/csjy-img.png" class="csjy-content-r-img" />
        </div>
      </div>
    </div>

    <!-- 超声考试 -->
    <div class="img-item">
      <img src="@/assets/image/csks-bg.png" class="img-item-bg" />
      <div class="img-item-wrap column">
        <div class="csks-title">
          <img class="csks-title-img" src="../assets/image/csks-title.png" alt="title" />
        </div>
        <div class="csks-box">
          <div class="csks-box-left"></div>
          <div class="csks-box-cent">
            <div class="csks-box-cent-item" @click="$router.push(`/liveShow`)">
              <div class="item-icon">
                <img src="../assets/image/csks-1.png" alt="icon" />
              </div>
              <div class="item-r">
                <div class="item-r-title">直播课堂</div>
                <div class="item-r-text">国内外知名超声医师汇聚一堂</div>
              </div>
            </div>
            <div class="csks-box-cent-item">
              <div class="item-icon">
                <img src="../assets/image/csks-2.png" alt="icon" />
              </div>
              <div class="item-r">
                <div class="item-r-title">备考题库</div>
                <div class="item-r-text">学员可通过备考题库进行考前模拟测验</div>
              </div>
            </div>
            <div class="csks-box-cent-item" @click="$router.push(`/user-exam/2`)">
              <div class="item-icon">
                <img src="../assets/image/csks-3.png" alt="icon" />
              </div>
              <div class="item-r">
                <div class="item-r-title">初级考试</div>
                <div class="item-r-text">
                  通过初级职业考试的学员，可获得初级职业证书
                </div>
              </div>
            </div>
            <div class="csks-box-cent-item" @click="$router.push(`/user-exam/1`)">
              <div class="item-icon">
                <img src="../assets/image/csks-4.png" alt="icon" />
              </div>
              <div class="item-r">
                <div class="item-r-title">高级考试</div>
                <div class="item-r-text">通过高级职业考试的学员，可获得高级职业证书</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 关于我们 -->
    <div class="img-item">
      <img src="@/assets/image/index_gywm.png" class="img-item-bg" />
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
// import NotificationBar from '@/components/NotificationBar.vue'
import { getLiveList, getNewsList } from '@/api/bus-course'
import { getBannerList } from '@/api/bus-banner'
import { goOpenLive, isUniAppWebView, navigateToUniAppHomeAsync } from '@/utils/custom'

export default defineComponent({
  name: 'TablesView',
  components: {},
  data() {
    return {
      titleStack: ['Admin', 'Tables'],
      tabIndex: 0,
      liveList: [],
      total: 0,
      loading: true,
      bannerList: [],
      queryParams: {
        pageIndex: 1,
        pageSize: 12,
        liveType: "1,2", // 1 直播预告  2正在直播   3 回看
      },
    }
  },
  filters: {
    formatCourseCode(v) {
      if (!v) return ''
      return v.replace('Course_', '')
    }
  },
  computed: {
    courseList() {
      const l = this.$store.getters['custom/getCourseList'] || []
      return l.filter((item, index) => index <= 3)
    }
  },
  async created() {
    if (await isUniAppWebView()) {
      console.log('in uniapp webview');
      let callbackUrl = this.$route.query.callback
      callbackUrl = decodeURIComponent(decodeURIComponent(callbackUrl))
      // 等待一段时间让SDK初始化完成，然后尝试跳转
      setTimeout(async () => {
        console.log('try navigateToUniAppHome');
        await navigateToUniAppHomeAsync((success) => {
          if (success) {
            // 如果成功跳转，则不执行后续的页面初始化逻辑
            return;
          }
          console.log('navigateToUniAppHomeAsync failed');
          // 如果跳转失败，继续执行正常的页面初始化
          this.initPage();
        }, callbackUrl);
      }, 500);
    } else {
      console.log('not in uniapp webview');
      // 不在uniapp环境中，直接初始化页面
      this.initPage();
    }
  },
  methods: {
    // 初始化页面
    initPage() {
      this.getNewsList();
      this.getBannerList();
    },
    getBannerList() {
      getBannerList({ status: 1, group: 'pcIndex' }).then(response => {
        this.bannerList = response.data.list;
      });
    },
    getLiveList() {
      this.loading = true;
      getLiveList(this.queryParams).then((response) => {
        this.liveList = response.data.list;
        this.total = response.data.count;
        this.loading = false;
      });
    },
    getNewsList() {
      this.loading = true;
      getNewsList(this.queryParams).then((response) => {
        this.liveList = response.data.list;
        this.total = response.data.count;
        this.loading = false;
      }).finally(() => {
        this.loading = false;
      });
    },
    getImgUrl(value) {
      return `/img/swtich/${value}.png`
    },
    changeTab(index) {
      this.tabIndex = index
      if (this.tabIndex == 0) {
        this.getNewsList()
      } else {
        this.getLiveList()
      }
    },
    routerTo() {
      if (this.tabIndex === 1) {
        this.$router.push('/liveShow')
      } else if (this.tabIndex === 0) {
        this.$router.push('/news')
      }
    },
    handleClickLive(item) {
      if (this.tabIndex === 0) {
        this.$router.push(`/newsDetail?id=${item.id}`)
        return;
      }
      this.$router.push(`/liveShow/${item.id}`)
      // goOpenLive(item, '');
    }
  },
})
</script>

<style scoped lang="scss">
.default-container {
  min-width: 1200px;
}
.index-top-r-cent {
  height: 400px;

  .index-top-r-cent-li {
    margin-top: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &:hover {
      background-color: rgba(0, 0, 0, 0.05);
      cursor: pointer;
    }

    &-title {
      flex: 1;
      font-size: 16px;
      font-weight: 500;
      color: #333;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding-right: 10px;

      span {
        margin-right: 10px;
        background-color: #53a6ca;
        display: inline-block;
        width: 5px;
        height: 5px;
        border-radius: 50%;
        vertical-align: middle;
        margin-top: -3px;
      }
    }

    &-time {
      font-size: 16px;
      color: #999;
    }
  }
}

.tab-active {
  color: #333 !important;
}

.index-top-r-top-tabs {
  display: flex;
  align-items: center;

  &-item {
    font-size: 18px;
    font-weight: 600;
    color: #666;
    padding: 0 15px;
    box-sizing: border-box;
    cursor: pointer;

    &:first-child {
      padding-left: 0px;
      position: relative;

      &::after {
        content: '';
        position: absolute;
        width: 2px;
        height: 20px;
        background-color: #999;
        top: 2px;
        right: 0;
        z-index: 1;
      }
    }
  }
}

.index-top-r-top-more {
  font-size: 14px;
  color: #666;
  cursor: pointer;

  &:hover {
    color: #2d93ff;
  }
}

.index-top-r-top {
  border-bottom: 2px solid rgba(204, 204, 204, 1);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 8px;
}

.index-top {
  position: relative;
  background: url("@/assets/image/index-banner.png") no-repeat center;
  background-size: 100% 100%;

  .index-top-wrap {
    padding: 28px 200px;
    box-sizing: border-box;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }

  .index-top-l {
    flex: 1;
    height: 460px;
    :deep(img){
      width: 100%;
      height: 460px;
      max-height: max-content;
      object-fit: cover;
      border-radius: 4px;
    }
    :deep(.carousel-indicator) {
      position: absolute;
      bottom: 0;
    }
  }

  .index-top-r {
    // margin-left: 10px;
    max-width: 50%;
    flex: 1;
    height: 460px;
    box-sizing: border-box;
    background: #ffffff;
    overflow: hidden;

    &-wrap {
      padding: 24px;
    }
  }
}

.csks-box {
  width: 100%;
  flex: 1;
  display: flex;
  align-items: center;
  box-sizing: border-box;

  &-left {
    width: 38%;
  }
}

.csks-box-cent {
  flex: 1;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding-left: 20px;
  box-sizing: border-box;

  .csks-box-cent-item {
    width: 49%;
    min-height: 100px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 0.5);
    border: 2px solid #ffffff;
    margin-top: 20px;
    padding: 20px;
    box-sizing: border-box;
    position: relative;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .item-icon {
      width: 60px;
      height: 60px;
      flex-shrink: 0;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .item-r {
      flex: 1;
      min-width: 0;
      margin-left: 20px;

      .item-r-title {
        font-size: 18px;
        font-weight: 700;
        letter-spacing: 0px;
        line-height: 26px;
        text-align: left;
        vertical-align: top;
      }

      .item-r-text {
        font-size: 13px;
        letter-spacing: 0px;
        line-height: 20px;
        color: rgba(48, 48, 48, 1);
        text-align: left;
        vertical-align: top;
        margin-top: 10px;
        font-weight: 600;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 100%;
      }
    }

    &:first-child {
      margin-top: 0;

      .item-icon {
        width: 68px;
        height: 53px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .item-r {
        .item-r-title {
          color: rgba(73, 168, 200, 1);
        }
      }
    }

    &:nth-child(2) {
      margin-top: 0;

      .item-r {
        .item-r-title {
          color: #2d93ff;
        }
      }
    }

    &:nth-child(3) {
      .item-r {
        .item-r-title {
          color: #ffc600;
        }
      }
    }

    &:nth-child(4) {
      .item-r {
        .item-r-title {
          color: #2d93ff;
        }
      }
    }
  }
}

.csks-title {
  width: 100%;
  padding-top: 4%;
  box-sizing: border-box;
  text-align: center;

  .csks-title-img {
    width: 275px;
    height: 58px;
  }
}

.csjy-content-l-item {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  width: 49%;
  height: 210px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 1px 4px rgba(206, 210, 213, 1);
  margin-bottom: 20px;
  padding: 16px;
  box-sizing: border-box;
  position: relative;
  cursor: pointer;

  .item-title {
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 1.08px;
    text-align: left;
    vertical-align: top;
    padding: 2px 10px;
    box-sizing: border-box;
    border-radius: 6px;
    display: inline-block;
  }

  .item-f-title {
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0.96px;
    line-height: 24px;
    text-align: left;
    vertical-align: top;
    margin-top: 8px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
  }

  .item-text-div {
    flex: 1;
    min-height: 0;
  }

  .item-text {
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0.84px;
    line-height: 22px;
    color: #303030;
    text-align: left;
    vertical-align: top;
    margin-top: 8px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    line-clamp: 4;
    -webkit-box-orient: vertical;
  }

  .item-info {
    font-size: 14px;
    letter-spacing: 0.84px;
    line-height: 22px;
    text-align: left;
    vertical-align: top;
    font-weight: 500;

    img {
      vertical-align: middle;
      margin-top: -3px;
      margin-left: 0px;
      width: 14px;
      height: 14px;
    }
  }

  &:first-child {
    .item-title {
      color: #1065c6;
      background-color: #d6ecfd;
    }

    .item-f-title {
      color: #1065c6;
    }

    .item-info {
      color: #1065c6;
    }
  }

  &:nth-child(2) {
    .item-title {
      color: #39b17c;
      background-color: #e5f6f2;
    }

    .item-f-title {
      color: #39b17c;
    }

    .item-info {
      color: #39b17c;
    }
  }

  &:nth-child(3) {
    .item-title {
      color: #ffa200;
      background-color: #fdf4ea;
    }

    .item-f-title {
      color: #ffa200;
    }

    .item-info {
      color: #ffa200;
    }
  }

  &:nth-child(4) {
    .item-title {
      color: #53a6ca;
      background-color: #d3e7f5;
    }

    .item-f-title {
      color: #53a6ca;
    }

    .item-info {
      color: #53a6ca;
    }
  }
}

.csjy-content {
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;

  .csjy-content-l {
    flex: 1;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-right: 20px;
    padding-top: 55px;
    box-sizing: border-box;
  }

  .csjy-content-r {
    position: relative;
    width: 500px;
    height: 500px;
    margin-top: -140px;

    &-img {
      width: 500px;
      height: 640px;
    }
  }
}

.csjy-title {
  width: 100%;
  padding: 70px 0;
  box-sizing: border-box;
  text-align: center;

  .csjy-title-img {
    width: 176px;
    height: 58px;
  }
}

.img-item {
  width: 100%;
  font-size: 0;
  position: relative;

  &-img {
    width: 100%;
    height: auto;
  }

  &-wrap {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
    padding: 0 200px;
    box-sizing: border-box;

    &.column {
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
    }
  }

  &.bg2 {
    background: url("../assets/image/csjy-bg.png") no-repeat center center;
    background-size: 100% 100%;
    padding: 0 200px;
    padding-bottom: 70px;
  }
}

.is-active .al img {
  filter: grayscale(0%);
}

.al img {
  filter: grayscale(100%);
}

.small-title {
  font-size: 14px;
}

.index-card {
  width: 300px;
  height: 255px;
  padding: 20px;
  /* 卡片内边距 */
  border-radius: 10px;
  /* 圆角边框 */
  border: 2px solid #87ceeb;
  /* 淡蓝色边框 */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  /* 阴影效果 */
  background-color: #fff;
  /* 卡片背景色 */
  text-align: center;
  /* 文字居中 */
}

@media (max-width: 1700px) {
  .csjy-title {
    padding: 40px 0;
  }

  .index-top {
    .index-top-wrap {
      padding: 20px 90px;
      box-sizing: border-box;
    }

    .index-top-l {
      height: 400px;
      :deep(img){
        height: 400px;
      }
    }

    .index-top-r {
      height: 400px;
    }

    :deep(.no-data) {
      img {
        width: 200px;
        height: 200px;
      }
    }
  }

  .csjy-content {
    .csjy-content-l-item {
      padding: 12px;
      height: 170px;

      .item-title {
        font-size: 14px;
      }

      .item-text {
        margin-top: 4px;
        line-height: 20px;
        -webkit-line-clamp: 3;
        line-clamp: 3;
      }
    }

    .csjy-content-r {
      width: 430px;
      margin-top: -100px;

      .csjy-content-r-img {
        width: 430px;
        height: auto;
      }
    }
  }

  .img-item-wrap {
    padding: 0 90px;
  }

  .img-item.bg2 {
    padding: 0 90px;
    padding-bottom: 70px;
  }
}

@media (max-width: 1400px) {
  .csjy-content {
    .csjy-content-l-item {
      padding: 12px;
      height: 155px;

      .item-text {
        -webkit-line-clamp: 2;
        line-clamp: 2;
      }
    }

    .csjy-content-r {
      width: 400px;
      margin-top: -90px;

      .csjy-content-r-img {
        width: 400px;
        height: auto;
      }
    }
  }

  .index-top {
    .index-top-wrap {
      padding: 16px 60px;
    }

    .index-top-l {
      height: 350px;
      :deep(img){
        height: 350px;
      }
    }

    .index-top-r {
      height: 350px;
    }

    :deep(.no-data) {
      img {
        width: 120px;
        height: 120px;
      }
    }
  }

  .img-item-wrap {
    padding: 0 60px;
  }

  .img-item.bg2 {
    padding: 0 60px;
    padding-bottom: 70px;
  }
}

/* 确保在1200px宽度时也能正常显示 */
@media (max-width: 1200px) {
  .index-top {
    .index-top-wrap {
      padding: 16px 40px;
    }

    .index-top-l {
      height: 320px;
      :deep(img){
        height: 320px;
      }
    }

    .index-top-r {
      height: 320px;
    }
  }

  .csjy-content {
    .csjy-content-l-item {
      padding: 10px;
      height: 140px;

      .item-text {
        font-size: 12px;
        line-height: 18px;
      }
    }

    .csjy-content-r {
      width: 350px;
      margin-top: -80px;

      .csjy-content-r-img {
        width: 350px;
      }
    }
  }

  .img-item-wrap {
    padding: 0 40px;
  }

  .img-item.bg2 {
    padding: 0 40px;
    padding-bottom: 50px;
  }

  .csks-box-cent .csks-box-cent-item {
    padding: 15px;

    .item-icon {
      width: 50px;
      height: 50px;
    }

    .item-r {
      margin-left: 15px;

      .item-r-title {
        font-size: 16px;
      }

      .item-r-text {
        font-size: 12px;
      }
    }
  }
}
</style>
